export enum StatusTagColors {
  open = 'highlight',
  paid = 'success',
  past_due = 'alert',
  voided = 'neutral'
}
